import axios from 'axios'
import { isArray } from './object'
import config, { uploadUrl } from './config.js'

const checkTokenValid = (response, cb) => {
  if (response.status === 200) {
    if (response.data.code === 101 || response.data.code === 100) {
      window.location.href = '/login'
      return
    }

    if (cb && typeof cb === 'function') {
      cb(response.data)
    } else {
      if (response.data && response.data.error) {
        throw new Error(response.data.error)
      }
    }

    return response.data
  }
  throw new Error(response.statusText)
}

const fetch = (method, url, {body = {}, data, param = {}} = {}, cb) => {
  let token = localStorage.token
  const isUpload = url.includes('upload')
  const contentType = isUpload ? 'multipart/form-data' : 'application/json'
  const headers = {
    'Content-Type': contentType,
    'Authorization': `Bearer ${token}`
  }
  if (method === 'get' || method === 'delete') {
    return axios[method](getUrl(url), {
      headers: headers
    }).then(res => {
      return checkTokenValid(res, cb)
    }).catch(err => {
      if (cb && typeof cb === 'function') {
        cb(null, err)
      } else {
        throw err
      }
    })
  }

  body.param = param

  if (data) {
    body.data = data
  }
  if (isUpload) {
    return axios[method](getUrl(url), data, {headers}).then(response => {
      return checkTokenValid(response, cb)
    }).catch(err => {
      if (cb && typeof cb === 'function') {
        cb(null, err)
      } else {
        throw err
      }
    })
  } else {
    return axios[method](getUrl(url), {...body.data}, {headers}).then(response => {
      return checkTokenValid(response, cb)
    }).catch(err => {
      if (cb && typeof cb === 'function') {
        cb(null, err)
      } else {
        throw err
      }
    })
  }
}

export const Network = {
  get (path, params) {
    let token = localStorage.token
    const url = params ? `${path}${queryString(params)}` : path
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      axios['get'](getUrl(url), {
        headers: headers
      }).then(res => {
        return checkTokenValid(res, resolve)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

const getUrl = (url) => {
  if (url.includes('upload')) {
    return uploadUrl
  }

  if (url.startsWith('/v1/')) {
    return config.server + url
  }

  if (url.startsWith('/api/') || url.startsWith('/test/')) {
    return config.server + url
  }
  return config.server + config.reqlApi + url
}

export const queryString = (obj) => {
  if (!obj) {
    return null
  }
  let result = ''
  for (const param in obj) {
    let content = ''
    if (!obj[param] && obj[param] !== 0) {
      continue
    }
    if (isArray(obj[param])) {
      if (obj[param].length === 0) {
        continue
      }
      content = obj[param].toString()
    } else {
      content = obj[param]
    }
    result += ((result) ? `&${param}=${content}` : `?${param}=${content}`)
  }
  return result
}

export default fetch



// WEBPACK FOOTER //
// ./src/utils/fetch.js